jQuery(document).ready(function($){

    $('.wecloud-card').matchHeight();
    $('.wecloud-card-header').matchHeight();


    adjustTextMargin();
    $(window).resize(function(){
        adjustTextMargin();

    })

    function adjustTextMargin(){
        let header_height = $('.header').height();
        $('.home-banner-image .banner-text').css('margin-top', header_height+'px');

    }

    adjustHeaderStyling();

    $(window).scroll(function(){
        adjustHeaderStyling();
    });


    function adjustHeaderStyling(){
        var $height = $(window).scrollTop();

        if($height > 0) {
            $('.header').addClass('white-header');
            } 
        else{

            $('.header').removeClass('white-header');

        }
    }

    $('.corporate-training-gallery').slick({
        dots: false,
        infinite: true,
        slidesToShow: 6,
        autoplay: true,
        arrows: false,
        slidesToScroll: 1,
        responsive: [
            {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
            }
            },
            {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
            }
            },
            {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
            }
            }
           
        ]
    });


    checkSliderInit();

    $(window).resize(function(e){
        checkSliderInit();
    });

    function checkSliderInit(){
        if(window.innerWidth < 768) {
            if(!$('.company-gallery-container').hasClass('slick-initialized')){
                mobileOnlySlider();
            }
    
        }else{
            if($('.company-gallery-container').hasClass('slick-initialized')){
                $('.company-gallery-container').slick('unslick');
            }
        }
    }

    function mobileOnlySlider(){
            $('.company-gallery-container').slick({
                dots: false,
                infinite: true,
                slidesToShow: 1,
                // variableWidth: true,
                autoplay: true,
                slidesToScroll: 1,
                prevArrow: '<i class="slick-arrow left fas fa-chevron-left"></i>',
                nextArrow: '<i class="slick-arrow right fas fa-chevron-right"></i>',
            });

    }

});